import React from 'react';
import { Navbar, Nav, NavbarToggler, NavbarBrand, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Collapse } from 'reactstrap';
import superfestas_cinza from '../resources/android-chrome-192x192.png'
import update from 'immutability-helper';
import { NavLink } from 'react-router-dom';
import Autenticacao from "../components/Autenticacao";
import Auth from '../config/Auth';

class NavigationBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      logged: props.logged != null ? props.logged : false 
    }

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const isOpen = !this.state.isOpen;

    this.setState(state => update(state, {
      isOpen: { $set: isOpen }
    }))
  }

  render() {
    return (
      <React.Fragment>
        <Navbar color="light" light expand="md" >
          <NavbarBrand href="/"><img src={superfestas_cinza} alt="Logo" style={{ height: '30px', width: '30px' }} /> <spam>Super Festas</spam></NavbarBrand>
          <NavbarToggler onClick={this.toggle} className="text-dark"><span class="navbar-toggler-icon"></span></NavbarToggler>
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="mr-auto" navbar> {
                Auth.isAuthenticated && false ?
                  <React.Fragment>
                    <UncontrolledDropdown nav inNavbar className="list-unstyled  m-2">
                      <DropdownToggle nav caret className="d-inline text-nowrap after-none text-dark"  >
                        Gerenciar
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          DJs
                        </DropdownItem>
                        <DropdownItem>
                          Eventos
                          </DropdownItem>
                        <DropdownItem>
                          Notícias
                        </DropdownItem>
                        <DropdownItem>
                          Selos
                        </DropdownItem>
                        <DropdownItem>
                          Usuários
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </React.Fragment>
                :
                  null
                }
                <NavLink to="/termos" className="text-secondary m-2"><span >Termos</span></NavLink>
                <NavLink to="/privacidade" className="text-secondary m-2"><span >Privacidade</span></NavLink>
              </Nav>
              <Nav navbar>
                <Autenticacao callback={() => { this.setState({ state: this.state }) }} />
              </Nav>
          </Collapse>
        </Navbar>
    </React.Fragment>
    )
  }
}

export default (NavigationBar)

